<template>
    <div class="row">
        <div class="form-group col-sm-12 col-md-4 col-lg-4">
            <label
                class="font-weight-bold"
                :class="required ? 'required' : ''"
                :for="'bankName' + _uid"
            >{{ $t('bankAccount.bankName')}}</label>
            <input
                type="text"
            class="form-control"
                v-model="bankAccount.bankName"
                v-validate="required ? 'required' : ''"
                :data-vv-as="$t('bankAccount.bankName')"
                :name="'bankName' + _uid"
                :id="'bankName' + _uid"
                :readonly="readonly"
            />
            <span
                class="text-danger"
                v-if="errors.has('bankName' + _uid)"
            >{{ errors.first('bankName' + _uid) }}</span>
        </div>

        <div class="form-group col-sm-12 col-md-4 col-lg-4">
            <label class="font-weight-bold" :class="required ? 'required': ''" :for="'bic' + _uid">
                {{
                $t('bankAccount.bic') }}
            </label>
            <input
                type="text"
                class="form-control"
                v-model="bankAccount.bic"
                v-validate="required ? 'required' : ''"
                :data-vv-as="$t('bankAccount.bic')"
                :name="'bic' + _uid"
                :id="'bic' + _uid"
                :readonly="readonly"
            />
            <span
                class="text-danger"
                v-if="errors.has('bic' + _uid)"
            >{{ errors.first('bic' + _uid) }}</span>
        </div>

        <div class="form-group col-sm-12 col-md-4 col-lg-4">
            <label class="font-weight-bold" :class="required ? 'required': ''" :for="'iban' + _uid">
                {{
                $t('bankAccount.iban') }}
            </label>
            <input
                type="text"
                class="form-control"
                v-model="bankAccount.iban"
                v-validate="required ? 'required' : ''"
                :data-vv-as="$t('bankAccount.iban')"
                :name="'iban' + _uid"
                :id="'iban' + _uid"
                :readonly="readonly"
            />
            <span
                class="text-danger"
                v-if="errors.has('iban' + _uid)"
            >{{ errors.first('iban' + _uid) }}</span>
        </div>

        <div v-if="showDescription" class="form-group col-12">
            <label
                class="font-weight-bold"
                :for="'description' + _uid"
            >{{ $t('bankAccount.description') }}</label>
            <textarea
                rows="3"
                class="form-control"
                v-model="bankAccount.description"
                :id="'description' + _uid"
                :name="'description' + _uid"
                :maxLength="descriptionMaxLength"
                :readonly="readonly"
            ></textarea>
            <p>{{$t('remainingSymbols')}} {{charactersRemaining}}</p>
        </div>
    </div>
</template>

<script>
import { BankAccount } from './../../models/models';

export default {
    props: {
        bankAccount: {
            type: BankAccount,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        descriptionMaxLength: {
            type: Number,
            default: 4000,
        },
        showDescription: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        charactersRemaining: function () {
            return (
                this.descriptionMaxLength - this.bankAccount.description.length
            );
        },
    },
};
</script>
